// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-module__header__2tBYV{font-family:'Gotham', 'Gotham Medium'}\n", ""]);
// Exports
exports.locals = {
	"header": "main-module__header__2tBYV"
};
module.exports = exports;
